// extracted by mini-css-extract-plugin
export default {"container":"LargeTextCustomField_container__5UUl2","value":"LargeTextCustomField_value__OXanY","showAll":"LargeTextCustomField_showAll__VDXxO"};